import { Link } from 'react-router-dom';

export function EhFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="from-zinc-900 to-slate-950 bg-gradient-to-b text-zinc-200 pt-12 pb-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm">
              © {currentYear} EveningHoney.AI - All rights reserved
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center">
            <div className="flex space-x-6 mb-4 md:mb-0 md:mr-8">
              <Link
                to="/legal/terms-of-service"
                className="hover:text-pink-600 text-sm"
              >
                Terms of Service
              </Link>
              <Link
                to="/legal/privacy-policy"
                className="hover:text-pink-600 text-sm"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
